<template>
  <div id="home">
  </div>
</template>

<script>
  export default {
    name: 'Home',
  };
</script>



// WEBPACK FOOTER //
// Home.vue?70e093df